import type { RouteRecordRaw } from 'vue-router'

export const legacyRoutes: RouteRecordRaw[] = [
  {
    path: '/invoices',
    redirect: '/orders',
  },
]
